<template>
    <div class="modal-window uts004 sec">
        <header class="modal-header">
            <div class="tit">{{popTitle}}</div>
        </header>
        
        <div class="modal-content">
            <div class="tab_ty1" id="tabsTy3">
                <ul class="tab-menu">
                    <li v-for="(tab, index) in tabsTy3" v-bind:key="tab.id" v-bind:class="{active:currentTab3===index}">
                        <button type="button" @click="changeTab(index)">{{tab}}</button>
                    </li>
                </ul>
                <div class="btn-team_work" v-show="btnShow">
                    <button type="button" class="btn-primary-smaller" @click="showTodoTeam">{{$i18nUtil.trans("button.todo.team.status","팀원 할 일 현황")}}</button>
                </div>
                <div class="tab-content">
                    <div v-show="currentTab3 == 0">
                        <div class="tab_ty2" id="tabsTy4">
                            <div class="tab-content">
                                <div>
                                    <div class="tb-header">
                                        <div>
                                            <input type="radio" name="perform" id="perform1" value="1" v-model="performTab1" @change="searchClickTab1"><label for="perform1">{{ $i18nUtil.trans("entity.todo.filter.executionPeriod","수행기간") }}</label>
                                            <input type="radio" name="perform" id="perform2" value="2" v-model="performTab1" @change="searchClickTab1"><label for="perform2">{{ $i18nUtil.trans("entity.todo.filter.completionDate","완료일") }}</label>
                                            <div class="dividing_line_ty1"></div>
                                            <div class="radio-wrap">
                                                <input type="radio" class="custom-radio" name="periodTab1" id="name1-1" checked @click="daySelTab1"><label for="name1-1">{{ $i18nUtil.trans("entity.todo.filter.day","일") }}</label>
                                                <input type="radio" class="custom-radio" name="periodTab1" id="name1-2" @click="weekSelTab1"><label for="name1-2">{{ $i18nUtil.trans("entity.todo.filter.week","주") }}</label>
                                            </div>
                                            <div class="dropdown relative ty1-custom" v-if="quarterSelYnTab1 === 'N'">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtnTab1" v-if="quarterSelYnTab1 === 'N'">{{quarterNameTab1}}</v-btn>
                                                        <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterNameTab1}}</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <div class="scroll">
                                                            <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSelTab1(item, index)">
                                                                <div class="tit"><button type="button" v-bind:class="{ active: currentIndexTab1 === index }">{{item.quarterName}}</button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </div>
                                            <div class="dropdown relative ty1-custom active" v-else>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtnTab1" v-if="quarterSelYnTab1 === 'N'">{{quarterNameTab1}}</v-btn>
                                                        <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterNameTab1}}</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <div class="scroll">
                                                            <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSelTab1(item, index)">
                                                                <div class="tit"><button type="button" v-bind:class="{ active: currentIndexTab1 === index }">{{item.quarterName}}</button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </div>
                                            <div class="calendar_box_grp small">
                                                <div class="calendar_box">
                                                    <datepicker 
                                                        format="yyyy.MM.dd" 
                                                        v-model="dateFromTab1"
                                                        :disabled="dayGbnTab1 === '0'"
                                                        @selected="dateFromChangeTab1">
                                                    </datepicker>
                                                </div>
                                                <span>~</span>
                                                <div class="calendar_box">
                                                    <datepicker 
                                                        format="yyyy.MM.dd" 
                                                        v-model="dateToTab1"
                                                        :disabled="dayGbnTab1 === '0'"
                                                        @selected="dateToChangeTab1">
                                                    </datepicker>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <input type="checkbox" name="" id="comp1" v-model="comp1Tab1" @change="searchClickTab1"><label for="comp1">{{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}</label>
                                            <input type="checkbox" name="" id="comp2" v-model="comp2Tab1" @change="searchClickTab1"><label for="comp2">{{ $i18nUtil.trans("entity.todo.status.completed","완료") }}</label>
                                            <div class="dividing_line_ty1"></div>
                                            <button v-show="btnShow" type="button" class="btn-primary-small black" @click="todoModalOpen()">{{$i18nUtil.trans("button.todo.add","할 일 추가하기")}}</button>
                                        </div>
                                    </div><!-- //tb-header -->
                                    <div class="scroll" id="scrollTab1">
                                        <v-data-table
                                            v-model="selected"
                                            :headers="myHeaders"
                                            :items="todoMyList"
                                            :sort-by.sync="sortByTab1"
                                            :sort-desc.sync="sortDescTab1"
                                            :must-sort="true"
                                            :single-select="singleSelect"
                                            :items-per-page="itemsPerPage"
                                            hide-default-footer
                                            class="tb-contents uts004_table new">

                                            <template v-slot:[`item.chk`]="{ item }">
                                                <div class="checkbox">
                                                <input type="checkbox" checked v-if="item.todoStatus === 'C'" />
                                                <input type="checkbox" v-if="item.todoStatus === 'P'" />
                                                <label class="ty2" @click="complete(item)"></label>
                                                </div>
                                            </template>

                                            <template v-slot:[`item.paperTitle`]="{ item }">
                                                <div class="cursor-pointer multi-ellipsis"
                                                    @click="moveLocation(item)"
                                                    v-if="item.paperTitle !== null">
                                                    {{ item.paperTitle }}
                                                </div>
                                                <!-- <div class="multi-ellipsis d-block">{{ item.paperTitle }}</div> -->
                                            </template>

                                            <template v-slot:[`item.todoTitle`]="{ item }">
                                                <div class="cursor-pointer multi-ellipsis d-block" 
                                                    v-html="item.todoTitle.split('\n').join('<br />')"
                                                    @click="todoInfoOpen(item)">
                                                </div>
                                            </template>
                                            <template v-slot:[`item.regUserName`]="{ item }">
                                                <div class="re-de">
                                                    <div class="re">
                                                        <div class="droplayer tooltipmember relative right">
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-bind="attrs" v-on="on">
                                                                        <b v-if="item.regUserId != userInfo.userId">{{ item.regUserName }}</b>
                                                                        <b v-else></b>
                                                                    </v-btn>
                                                                </template>
                                                                <div class="dropdown-list">
                                                                    <UserTooltip
                                                                    :userId="item.regUserId"
                                                                    />
                                                                </div>
                                                            </v-menu>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                            <template v-slot:[`item.receiver`]="{ item }">
                                                <div v-if="item.receiverCount != 1" >
                                                    <button
                                                        type="button"
                                                        class="btn-txt-link"
                                                        @click="receiverListOpen(item.todoMainId)">
                                                        {{$i18nUtil.trans("message.PrevQrtUnit.004","조회")}}
                                                    </button>
                                                </div>
                                                <div v-else-if="item.receiverCount == 1">
                                                    {{$i18nUtil.getLanguage() === 'ko' ? item.chargerName:item.chargerNameEn}}
                                                </div>
                                            </template>
                                            <template v-slot:[`item.todoEndDate`]="{ item }">
                                                <div :class="
                                                    $moment($moment(item.todoEndDate).format('YYYY.MM.DD')).diff($moment(new Date()).format('YYYY.MM.DD'), 'days') <= 3
                                                    ? item.todoStatus === 'P' ? 'deadline':''
                                                    : ''
                                                ">
                                                    ~{{ $moment(item.todoEndDate).format('YYYY.MM.DD') }}
                                                </div>
                                            </template>
                                            
                                            <template v-slot:[`item.terDate`]="{ item }">
                                                <div v-if="item.terDate != null">{{ $moment(item.terDate).format('YYYY.MM.DD') }}</div>
                                                <div v-else></div>
                                            </template>

                                            <template slot="no-data">
                                                <div class="nodata-txt-noicon">
                                                    <v-alert :value="true" v-if="comp1Tab1 === true && comp2Tab1 === true">
                                                        {{$i18nUtil.trans("search.037","등록된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else-if="comp1Tab1 === true && comp2Tab1 === false">
                                                        {{$i18nUtil.trans("search.029","미완료된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else-if="comp1Tab1 === false && comp2Tab1 === true">
                                                        {{$i18nUtil.trans("search.031","완료된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else>
                                                        {{$i18nUtil.trans("search.037","등록된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                </div>
                                            </template>
                                        </v-data-table>
                                        <div v-show="pageCount > 1" class="pagination">
                                            <v-pagination
                                                v-model="page"
                                                circle
                                                :length="pageCount"
                                                :total-visible="7"
                                                @input="getTodoMyList"
                                            ></v-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-show="currentTab3 == 1">
                        <div class="tab_ty2" id="tabsTy4">
                            <div class="tab-content">
                                <div>
                                    <div class="tb-header">

                                        <div>
                                            <input type="radio" name="perform2" id="perform2-1" value="1" v-model="performTab2" @change="searchClickTab2"><label for="perform2-1">{{ $i18nUtil.trans("entity.todo.filter.executionPeriod","수행기간") }}</label>
                                            <input type="radio" name="perform2" id="perform2-2" value="2" v-model="performTab2" @change="searchClickTab2"><label for="perform2-2">{{ $i18nUtil.trans("entity.todo.filter.completionDate","완료일") }}</label>
                                            <div class="dividing_line_ty1"></div>
                                            <div class="radio-wrap">
                                                <input type="radio" class="custom-radio" name="periodTab2" id="name2-1" checked @click="daySelTab2"><label for="name2-1">{{ $i18nUtil.trans("entity.todo.filter.day","일") }}</label>
                                                <input type="radio" class="custom-radio" name="periodTab2" id="name2-2" @click="weekSelTab2"><label for="name2-2">{{ $i18nUtil.trans("entity.todo.filter.week","주") }}</label>
                                            </div>
                                            <div class="dropdown relative ty1-custom" v-if="quarterSelYnTab2 === 'N'">
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtnTab2" v-if="quarterSelYnTab2 === 'N'">{{quarterNameTab2}}</v-btn>
                                                        <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterNameTab2}}</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <div class="scroll">
                                                            <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSelTab2(item, index)">
                                                                <div class="tit"><button type="button" v-bind:class="{ active: currentIndexTab2 === index }">{{item.quarterName}}</button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </div>
                                            <div class="dropdown relative ty1-custom active" v-else>
                                                <v-menu offset-y>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn v-bind="attrs" style="width:120px" @click="quarterSelBtnTab2" v-if="quarterSelYnTab2 === 'N'">{{quarterNameTab2}}</v-btn>
                                                        <v-btn v-bind="attrs" v-on="on" style="width:120px;" v-else>{{quarterNameTab2}}</v-btn>
                                                    </template>
                                                    <div class="dropdown-list">
                                                        <div class="scroll">
                                                            <div class="dropdown-list-item" v-for="(item, index) in quarter" :key="'pattern' + index" @click="quarterSelTab2(item, index)">
                                                                <div class="tit"><button type="button" v-bind:class="{ active: currentIndexTab2 === index }">{{item.quarterName}}</button></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </v-menu>
                                            </div>
                                            <div class="calendar_box_grp small">
                                                <div class="calendar_box">
                                                    <datepicker 
                                                        format="yyyy.MM.dd" 
                                                        v-model="dateFromTab2"
                                                        :disabled="dayGbnTab2 === '0'"
                                                        @selected="dateFromChangeTab2">
                                                    </datepicker>
                                                </div>
                                                <span>~</span>
                                                <div class="calendar_box">
                                                    <datepicker 
                                                        format="yyyy.MM.dd" 
                                                        v-model="dateToTab2"
                                                        :disabled="dayGbnTab2 === '0'"
                                                        @selected="dateToChangeTab2">
                                                    </datepicker>
                                                </div>
                                            </div>
                                        </div>

                                        <div>
                                            <input type="checkbox" name="" id="comp2-1" v-model="comp1Tab2" @change="searchClickTab2"><label for="comp2-1">{{ $i18nUtil.trans("entity.todo.status.incomplete","미완료") }}</label>
                                            <input type="checkbox" name="" id="comp2-2" v-model="comp2Tab2" @change="searchClickTab2"><label for="comp2-2">{{ $i18nUtil.trans("entity.todo.status.completed","완료") }}</label>
                                            <div class="dividing_line_ty1"></div>
                                            <button v-show="btnShow" type="button" class="btn-primary-small black" @click="todoModalOpen()">{{$i18nUtil.trans("button.todo.add","할 일 추가하기")}}</button>
                                        </div>
                                    </div><!-- //tb-header -->
                                    <div class="scroll" id="scrollTab2">
                                        <v-data-table
                                            v-model="selected"
                                            :headers="reqHeaders"
                                            :items="todoReqList"
                                            :sort-by.sync="sortByTab2"
                                            :sort-desc.sync="sortDescTab2"
                                            :must-sort="true"
                                            :single-select="singleSelect"
                                            :items-per-page="itemsPerPage"
                                            hide-default-footer
                                            class="tb-contents uts004_table">

                                            <template v-slot:[`item.chk`]="{ item }">
                                                <div class="checkbox">
                                                <input type="checkbox" checked v-if="item.todoStatus === 'C'" />
                                                <input type="checkbox" v-if="item.todoStatus === 'P'" />
                                                <label class="ty2" @click="complete(item)"></label>
                                                </div>
                                            </template>

                                            <template v-slot:[`item.paperTitle`]="{ item }">
                                                <div class="cursor-pointer multi-ellipsis"
                                                    @click="moveLocation(item)"
                                                    v-if="item.paperTitle !== null">
                                                    {{ item.paperTitle }}
                                                </div>
                                                <!-- <div class="multi-ellipsis d-block">{{ item.paperTitle }}</div> -->
                                            </template>

                                            <template v-slot:[`item.todoTitle`]="{ item }">
                                                <div class="cursor-pointer multi-ellipsis d-block" 
                                                    v-html="item.todoTitle.split('\n').join('<br />')"
                                                    @click="todoInfoOpen(item)">
                                                </div>
                                            </template>

                                            <template v-slot:[`item.chargerName`]="{ item }">
                                                <div class="re-de">
                                                    <div class="re">
                                                        <div class="droplayer tooltipmember relative right">
                                                            <v-menu offset-y>
                                                                <template v-slot:activator="{ on, attrs }">
                                                                    <v-btn v-bind="attrs" v-on="on">
                                                                        <b>{{ item.chargerName }}</b>
                                                                    </v-btn>
                                                                </template>
                                                                <div class="dropdown-list">
                                                                    <UserTooltip
                                                                    :userId="item.chargerId"
                                                                    />
                                                                </div>
                                                            </v-menu>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>

                                            <template v-slot:[`item.todoEndDate`]="{ item }">
                                                <div :class="
                                                    $moment($moment(item.todoEndDate).format('YYYY.MM.DD')).diff($moment(new Date()).format('YYYY.MM.DD'), 'days') <= 3
                                                    ? item.todoStatus === 'P' ? 'deadline':''
                                                    : ''
                                                ">
                                                    ~{{ $moment(item.todoEndDate).format('YYYY.MM.DD') }}
                                                </div>
                                            </template>

                                            <template v-slot:[`item.terDate`]="{ item }">
                                                <div v-if="item.terDate != null">{{ $moment(item.terDate).format('YYYY.MM.DD') }}</div>
                                                <div v-else></div>
                                            </template>

                                            <template slot="no-data">
                                                <div class="nodata-txt-noicon">
                                                    <v-alert :value="true" v-if="comp1Tab2 === true && comp2Tab2 === true">
                                                        {{$i18nUtil.trans("search.038","요청한 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else-if="comp1Tab2 === true && comp2Tab2 === false">
                                                        {{$i18nUtil.trans("search.029","미완료된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else-if="comp1Tab2 === false && comp2Tab2 === true">
                                                        {{$i18nUtil.trans("search.031","완료된 할 일이 없습니다.")}}
                                                    </v-alert>
                                                    <v-alert :value="true" v-else>
                                                        {{$i18nUtil.trans("search.038","요청한 할 일이 없습니다.")}}
                                                    </v-alert>
                                                </div>
                                            </template>
                                        </v-data-table>
                                        <div v-show="pageCount > 1" class="pagination">
                                            <v-pagination
                                                v-model="page"
                                                circle
                                                :length="pageCount"
                                                :total-visible="7"
                                                @input="getTodoReqList"
                                            ></v-pagination>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <modals-container @updateTodoList="initTabSelect"> </modals-container>
        </div>
    </div>
</template>
<script>
import todoInfo from "@/components/cowork/general/board/todo/popup/TodoInfo.vue";
import receiverList from "@/components/cowork/general/board/todo/popup/ReceiverList.vue";
import todoAddModal from "./TodoAddModal";
import Datepicker from 'vuejs-datepicker';
import EventBus from "@/js/eventbus/eventBus";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";

export default {
    components: {
        Datepicker,
        UserTooltip,
    },
    data() {
        return {
            /* tenantId */
            tenantId: localStorage.getItem("tenantId"),
            paperId: '',
            btnShow: true,
            popTitle:'',
            popGubun:'1',
            ellipsisTimer: null,
            comp1Tab1: false,
            comp2Tab1: false,
            performTab1: '1',
            dayGbnTab1: '1',
            currentIndexTab1: '',
            dateFromTab1: new Date(this.$moment()),
            dateToTab1: new Date(this.$moment()),
            comp1Tab2: false,
            comp2Tab2: false,
            performTab2: '1',
            dayGbnTab2: '1',
            currentIndexTab2: '',
            dateFromTab2: new Date(this.$moment()),
            dateToTab2: new Date(this.$moment()),
            currentTab3: 0,
            tabsTy3: [this.$i18nUtil.trans("title.TodoPersonal.tab3.001","나의 할 일"), this.$i18nUtil.trans("title.TodoPersonal.tab3.002","요청한 할 일")],
            page: 1,
            pageCount: 0,
            itemsPerPage: 20,
            singleSelect: false,
            selected: [],
            myHeaders: [
                { text: "", value: "chk", sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.filter.paperTitle","Task(보드)"), align: 'center', value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.content","할 일 내용"), align: 'center', value: 'todoTitle', sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.requester","요청자"), align: 'center', value: 'regUserName', sortable: true },
                { text: this.$i18nUtil.trans("entity.user.receiver","수신자"), align: 'center', value: 'receiver', sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.filter.expirationDate","만료일"),  align: 'center', value: 'todoEndDate', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.completionDate","완료일"),  align: 'center', value: 'terDate', sortable: true }
            ],
            reqHeaders: [
                { text: "", value: "chk", sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.filter.paperTitle","Task(보드)"), align: 'center', value: 'paperTitle', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.content","할 일 내용"), align: 'center', value: 'todoTitle', sortable: false },
                { text: this.$i18nUtil.trans("entity.todo.personInCharge","담당자"), align: 'center', value: 'chargerName', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.expirationDate","만료일"),  align: 'center', value: 'todoEndDate', sortable: true },
                { text: this.$i18nUtil.trans("entity.todo.filter.completionDate","완료일"),  align: 'center', value: 'terDate', sortable: true }
            ],
            changeTableData: false,
            userInfo: {},
            sortByTab1: 'paperTitle',
            sortDescTab1: false,
            sortByTab2: 'paperTitle',
            sortDescTab2: false,
            quarterNameTab1: this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            quarterNameTab2: this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            quarter : [],
            todoMyList: [],
            todoReqList: [],
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                theme: "toasted-primary",
                position: "bottom-left",
                duration: 3000,
                },
            },
            thisQuarterName: '',
            thisQuarterCd: '',
            thisQuarterIndex: '',
            quarterSelYnTab1: 'N',
            quarterSelYnTab2: 'N',
        };
    },
    watch : {
        sortByTab1: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoMyList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        sortDescTab1: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoMyList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        sortByTab2: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoReqList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        sortDescTab2: {
            handler() {
                let obj = this;
                obj.page = 1;
                obj.pageCount = 0;
                obj.todoReqList = [];
                if(obj.changeTableData != true) {
                    obj.changeTableData = true;
                }
            }
        },
        changeTableData: {
            handler() {
                let obj = this;
                if(obj.changeTableData == true) {
                setTimeout(() => {
                    obj.changeTableData = false;
                    obj.selected = [];
                    obj.initTabSelect();
                }, 500);
                }
            },
            deep: true
        }
    },
    created() {
        // 유틸에서 호출
        if(this.$route.query.startDate != null && this.$route.query.startDate != "udefiend" && this.$route.query.startDate != ""){
            this.dateFromTab1 = this.$moment(this.$route.query.startDate).format("YYYY.MM.DD");
            this.dateToTab1 = this.$moment(this.$route.query.startDate).format("YYYY.MM.DD");
        }

        if(this.$route.params.paperId == null) {
            this.popTitle = this.$i18nUtil.trans("entity.todo","할 일");
            this.popGubun = '1';
        } 
        // 보드에서 호출
        else {
            this.paperId = this.$route.params.paperId;
            this.btnShow = false;
            this.popTitle = this.$i18nUtil.trans("title.TodoPersonal.001","보드 내 할 일");
            this.popGubun = '2';
        }
        EventBus.$off("refreshTodoNewPage");
        EventBus.$on("refreshTodoNewPage", (payload) => {
           this.initTabSelect();
        });
        /* 분기 데이터 생성 */
        this.quarterCreate();
    },
    mounted() {
        this.multiElipsis(2);
        // left 메뉴 알림 모달창에서 할 일 관련 이벤트 발생시. 탭선택.
        if(this.$route.query.index != null && this.$route.query.index == 1){
            let index = this.$route.query.index;
            if(index == 1){
                this.currentTab3 = 1;
                this.getTodoReqList();
            }else{
                this.getTodoMyList();
            }
        }else {
            this.getTodoMyList();
        }
        this.getUserInfo();
    },
    methods: {
        ...mapActions("modals", ["showToast", "showModal"]),
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        /* 전체탭 초기화후 현재탭 조회 */
        initTabSelect() {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.todoReqList = [];

            if (this.currentTab3 === 0) {
                this.getTodoMyList();
            } else {
                this.getTodoReqList();
            }
        },
        /* 탭 변경 이벤트 */
        changeTab(index) {
            if(this.currentTab3 === index) return;
            this.currentTab3 = index;

            if (this.currentTab3 === 0) {
                this.page = 1;
                this.pageCount = 0;
                this.todoMyList = [];
                this.sortByTab1 = 'paperTitle';
                this.sortDescTab1 = false;
                this.getTodoMyList();
            } else {
                this.page = 1;
                this.pageCount = 0;
                this.todoReqList = [];
                this.sortByTab2 = 'paperTitle';
                this.sortDescTab2 = false;
                this.getTodoReqList();              
            }
        },
        /* 할 일 상세 팝업 */
        todoInfoOpen(param) {
            const modalInfo = {
                name: "todoInfo",
                obj: this.$modal,
                component: todoInfo,
                width: "800px",
                todoId: param.todoId,
                receiverCount : param.receiverCount,
                todoMainId : param.todoMainId
            };
            this.showModal(modalInfo);
        },
        /* 수신자 리스트 팝업 */
        receiverListOpen(param) {
            const modalInfo = {
                name: "receiverList",
                obj: this.$modal,
                component: receiverList,
                width: "800px",
                todoMainId: param,
            };
            this.showModal(modalInfo);
        },
        /* 할 일 추가하기 팝업 */
        todoModalOpen() {
            const modalInfo = {
                name: "todoAddModal",
                obj: this.$modal,
                component: todoAddModal,
                width: "800px",
                userInfo: this.userInfo,
            };
            this.showModal(modalInfo);
        },
        /* 팀원 할 일 팝업 */
        showTodoTeam() {
            let hanwha = $(location).attr("origin");
            let width = 1264;
            if(this.$i18nUtil.getLanguage() === 'en') width = 1500;
            window.open(
                hanwha + "/general/TodoTeam",
                "_blank",
                "width="+width+", height=800"
            );
        },
        /* 사용자 정보 조회 */
        getUserInfo() {
            let userInfo = "/api/copaper/decision/userInfo";
            this.$axios.post(userInfo).then((response) => {
                this.userInfo = response.data.result;
            });
        },
        /* 현재날짜 기준으로 분기 생성
            (지난해 1~4분기, 올해 현재분기까지, 현재분기+1분기)
        */
        quarterCreate() {
            for(var i=this.$moment().format('Q');i > 0;i-- ) {
                let strMonth1 = (i*3)-2;
                // 현재 분기 + 1 push , 현재분기 데이터 세팅 
                if(i == this.$moment().format('Q')) {
                    if(this.$moment().format('Q') == 4) { // 다음해 년도 
                        this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(-1, "years").format('YYYY'), quarter: 1}), quarterCd:this.$moment().subtract(-1, "years").format('YYYY')+'01'});
                    } else {
                        let q = (i*1) +1;
                        let strMonth2 = (q*3)-2;
                        if(strMonth2 >= 10) {
                            // console.log("durl emfjdhd : ", q);
                            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: q}), quarterCd:this.$moment().format('YYYY')+strMonth2});
                        } else {
                            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: q}), quarterCd:this.$moment().format('YYYY')+'0'+strMonth2});
                        }
                    }
                    // 현재 분기 데이터 세팅.
                    if(strMonth1 >= 10) { // 4분기 
                        this.thisQuarterName = this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i});
                        this.thisQuarterCd = this.$moment().format('YYYY')+strMonth1;
                        this.thisQuarterIndex = this.quarter.length;
                    }else{ // 1, 2, 3 분기 
                        this.thisQuarterName = this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i});
                        this.thisQuarterCd = this.$moment().format('YYYY')+'0'+strMonth1;
                        this.thisQuarterIndex = this.quarter.length;
                    }
                }
                // 올해 현재분기까지 역순 push
                if(strMonth1 >= 10) {
                    this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+strMonth1});
                } else {
                    this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().format('YYYY'), quarter: i}), quarterCd:this.$moment().format('YYYY')+'0'+strMonth1});
                }
            }

            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 4}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'10'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 3}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'07'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 2}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'04'});
            this.quarter.push({quarterName: this.$i18nUtil.trans("entity.todo.filter.yearQuarter","{year}년 {quarter}분기", {year: this.$moment().subtract(1, "years").format('YYYY'), quarter: 1}), quarterCd:this.$moment().subtract(1, "years").format('YYYY')+'01'});
        },  
        /* 시작일 변경 이벤트(나의 할 일 탭) */
        dateFromChangeTab1(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoMyList = [];
                if(this.dayGbnTab1 === '1') {
                    this.dateToTab1 = this.dateFromTab1;
                } else if(this.dayGbnTab1 === '2') {
                    this.dateFromTab1 = this.$moment(this.dateFromTab1).day("Monday").format('L');
                    this.dateToTab1 = this.$moment(this.dateFromTab1).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoMyList();
            })
        },
        /* 시작일 변경 이벤트(요청한 할 일 탭) */
        dateFromChangeTab2(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoReqList = [];
                if(this.dayGbnTab2 === '1') {
                    this.dateToTab2 = this.dateFromTab2;
                } else if(this.dayGbnTab2 === '2') {
                    this.dateFromTab2 = this.$moment(this.dateFromTab2).day("Monday").format('L');
                    this.dateToTab2 = this.$moment(this.dateFromTab2).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoReqList();
            })
        },
        /* 종료일 변경 이벤트(나의 할 일 탭) */
        dateToChangeTab1(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoMyList = [];
                if(this.dayGbnTab1 === '1') {
                    this.dateFromTab1 = this.dateToTab1;
                } else if(this.dayGbnTab1 === '2') {
                    this.dateFromTab1 = this.$moment(this.dateToTab1).day("Monday").format('L');
                    this.dateToTab1 = this.$moment(this.dateToTab1).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoMyList();
            })
        },
        /* 종료일 변경 이벤트(요청한 할 일 탭) */
        dateToChangeTab2(date) {
            this.$nextTick(() => {
                this.page = 1;
                this.pageCount = 0;
                this.todoReqList = [];
                if(this.dayGbnTab2 === '1') {
                    this.dateFromTab2 = this.dateToTab2;
                } else if(this.dayGbnTab2 === '2') {
                    this.dateFromTab2 = this.$moment(this.dateToTab2).day("Monday").format('L');
                    this.dateToTab2 = this.$moment(this.dateToTab2).day("Monday").subtract(-6, "days").format('L');
                }
                this.getTodoReqList();
            })
        },
        /* 일버튼 클릭 이벤트(나의 할 일 탭) */
        daySelTab1() {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.dayGbnTab1 = '1';
            this.quarterNameTab1 = this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            this.currentIndexTab1 = '';
            this.dateFromTab1 = this.$moment().format('L');
            this.dateToTab1 = this.$moment().format('L');
            this.getTodoMyList();
            this.quarterSelYnTab1 = 'N';
        },
        /* 일버튼 클릭 이벤트(요청한 할 일 탭) */
        daySelTab2() {
            this.page = 1;
            this.pageCount = 0;
            this.todoReqList = [];
            this.dayGbnTab2 = '1';
            this.quarterNameTab2 = this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            this.currentIndexTab2 = '';
            this.dateFromTab2 = this.$moment().format('L');
            this.dateToTab2 = this.$moment().format('L');
            this.getTodoReqList();
            this.quarterSelYnTab2 = 'N';
        },
        /* 주버튼 클릭 이벤트(나의 할 일 탭) */
        weekSelTab1() {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.dayGbnTab1 = '2';
            this.quarterNameTab1 = this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            this.currentIndexTab1 = '';

            this.dateFromTab1 = this.$moment().day("Monday").format('L');
            this.dateToTab1 = this.$moment().day("Monday").subtract(-6, "days").format('L');
            this.getTodoMyList();
            this.quarterSelYnTab1 = 'N';
        },
        /* 주버튼 클릭 이벤트(요청한 할 일 탭) */
        weekSelTab2() {
            this.page = 1;
            this.pageCount = 0;
            this.todoReqList = [];
            this.dayGbnTab2 = '2';
            this.quarterNameTab2 = this.$i18nUtil.trans("entity.todo.filter.quarter","분기"),
            this.currentIndexTab2 = '';

            this.dateFromTab2 = this.$moment().day("Monday").format('L');
            this.dateToTab2 = this.$moment().day("Monday").subtract(-6, "days").format('L');
            this.getTodoReqList();
            this.quarterSelYnTab2 = 'N';
        },
        /* 분기버튼 이벤트(나의 할 일 탭) */
        quarterSelBtnTab1() {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.dayGbnTab1 = '0';
            $("input:radio[name=periodTab1]").prop("checked",false);
            this.quarterNameTab1 = this.thisQuarterName;
            this.currentIndexTab1 = this.thisQuarterIndex;
            this.dateFromTab1 = this.$moment(this.thisQuarterCd+'01').format('L');
            this.dateToTab1 = this.$moment(this.thisQuarterCd+this.$moment(this.thisQuarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoMyList();
            this.quarterSelYnTab1 = 'Y';
        },
        /* 분기선택 이벤트(나의 할 일 탭) */
        quarterSelTab1(item, index) {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.dayGbnTab1 = '0';
            $("input:radio[name=periodTab1]").prop("checked",false);
            this.quarterNameTab1 = item.quarterName;
            this.currentIndexTab1 = index;
            this.dateFromTab1 = this.$moment(item.quarterCd+'01').format('L');
            this.dateToTab1 = this.$moment(item.quarterCd+this.$moment(item.quarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoMyList();
        },
        /* 분기버튼 이벤트(요청한 할 일 탭) */
        quarterSelBtnTab2() {
            this.page = 1;
            this.pageCount = 0;
            this.todoReqList = [];
            this.dayGbnTab2 = '0';
            $("input:radio[name=periodTab2]").prop("checked",false);
            this.quarterNameTab2 = this.thisQuarterName;
            this.currentIndexTab2 = this.thisQuarterIndex;
            this.dateFromTab2 = this.$moment(this.thisQuarterCd+'01').format('L');
            this.dateToTab2 = this.$moment(this.thisQuarterCd+this.$moment(this.thisQuarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoReqList();
            this.quarterSelYnTab2 = 'Y';
        },
        /* 분기선택 이벤트(요청한 할 일 탭) */
        quarterSelTab2(item, index) {
            this.page = 1;
            this.pageCount = 0;
            this.todoReqList = [];
            this.dayGbnTab2 = '0';
            $("input:radio[name=periodTab2]").prop("checked",false);
            this.quarterNameTab2 = item.quarterName;
            this.currentIndexTab2 = index;
            this.dateFromTab2 = this.$moment(item.quarterCd+'01').format('L');
            this.dateToTab2 = this.$moment(item.quarterCd+this.$moment(item.quarterCd+'01').subtract(-2, "months").endOf('month').format('DD')).subtract(-2, "months").format('L');
            this.getTodoReqList();
        },
        /* 나의 할 일 조회조건 클릭 이벤트(수행기간/완료일, 미완료/완료) */
        searchClickTab1() {
            this.page = 1;
            this.pageCount = 0;
            this.todoMyList = [];
            this.getTodoMyList();
        },
        /* 요청한 할 일 조회조건 클릭 이벤트(수행기간/완료일, 미완료/완료) */
        searchClickTab2() {
            this.page = 1;
            this.pageCount = 0;
            this.todoReqList = [];
            this.getTodoReqList();
        },
        /* 할 일 상태 변경 */
        complete(param, event) {
            let para = { todoId: param.todoId };
            let complete = "/api/copaper/todo/complete";

            this.$axios.post(complete, para).then((response) => {
                if (param.todoStatus === "P") {
                    this.toastInfo.message = this.$i18nUtil.trans('TB020');
                } else if (param.todoStatus === "C") {
                    this.toastInfo.message = this.$i18nUtil.trans('TB021');
                }
                this.showToast(this.toastInfo);
                this.refreshBoard(param);
                this.initTabSelect();
            });
        },
        refreshBoard(param){
            const self = this;
            self.COWORK_REST_SIMPLE_ACTION({
                params: { by:"todo", paperId: param.paperId, todoId: param.todoId, update: true },
                url: "/api/copaper/paper/block/refreshBlockBy",
                method: "post",
            }).then((response) => { });
        },
        /* 나의 할 일 목록 조회 */
        getTodoMyList() {
            let obj = this;
            let compGbn = 0;

            if(obj.comp1Tab1 === true && obj.comp2Tab1 === false) {
                compGbn = 1;
            } else if(obj.comp1Tab1 === false && obj.comp2Tab1 === true) {
                compGbn = 2;
            }

            let reqData = {};
            reqData.params = {
                currentPage: obj.page,
                itemsPerPage: obj.itemsPerPage,
                startDate: obj.$moment(this.dateFromTab1).format("YYYYMMDD"),
                endDate: obj.$moment(this.dateToTab1).format("YYYYMMDD"),
                performGbn: obj.performTab1,
                compGbn:compGbn,
                popGubun:obj.popGubun,
                paperId:obj.paperId,
                sortBy:obj.sortByTab1,
                sortDesc:obj.sortDescTab1,
            };
            reqData.url = "/api/copaper/todo/getTodoMyList";
            reqData.method = "post";

            //프로그레스바 시작
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => {
                //프로그레스바 종료
                this.hideLoadingbar();
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    let list = res.result.todoMyList;
                    list.forEach(item => {
                        if(obj.$i18nUtil.getLanguage() === 'ko') {

                        }else{
                            item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
                            item.chargerName = item.chargerNameEn != null ? item.chargerNameEn : item.chargerName;
                        }
                    })
                    obj.todoMyList = list;
                    obj.pageCount = res.result.todoMyListPageCount;
                    const tableTab1 = document.getElementById("scrollTab1");
                    tableTab1.scrollTop = 0;
                }
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        /* 요청한 할 일 목록 조회 */
        getTodoReqList() {
            let obj = this;
            let compGbn = 0;

            if(obj.comp1Tab2 === true && obj.comp2Tab2 === false) {
                compGbn = 1;
            } else if(obj.comp1Tab2 === false && obj.comp2Tab2 === true) {
                compGbn = 2;
            }

            let reqData = {};
            reqData.params = {
                currentPage: obj.page,
                itemsPerPage: obj.itemsPerPage,
                startDate: obj.$moment(this.dateFromTab2).format("YYYYMMDD"),
                endDate: obj.$moment(this.dateToTab2).format("YYYYMMDD"),
                performGbn: obj.performTab2,
                compGbn:compGbn,
                popGubun:obj.popGubun,
                paperId:obj.paperId,
                sortBy:obj.sortByTab2,
                sortDesc:obj.sortDescTab2,
            };
            reqData.url = "/api/copaper/todo/getTodoReqList";
            reqData.method = "post";

            //프로그레스바 시작
            this.showLoadingbar();
            obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then((res) => {
                //프로그레스바 종료
                this.hideLoadingbar();
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    let list = res.result.todoReqList;
                    list.forEach(item => {
                        if(obj.$i18nUtil.getLanguage() === 'ko') {

                        }else{
                            item.regUserName = item.regUserNameEn != null ? item.regUserNameEn : item.regUserName;
                            item.chargerName = item.chargerNameEn != null ? item.chargerNameEn : item.chargerName;
                        }
                    })
                    obj.todoReqList = list
                    obj.pageCount = res.result.todoReqListPageCount;
                    const tableTab2 = document.getElementById("scrollTab2");
                    tableTab2.scrollTop = 0;
                }
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        /* IE도 적용되는 말줄임 처리 */
        multiElipsis(ellipsisLine) {
            if (this.ellipsisTimer) {
                clearTimeout(this.ellipsisTimer);
            }

            this.ellipsisTimer = setTimeout(function () {
                if ($(".multi-ellipsis").length > 0) {
                var omle = $(".multi-ellipsis");
                var $txtR = $("<div class='txtEllipsis'></div>");
                var $body = $("body");
                omle.each(function (idx) {
                    var _this = $(this);
                    var orinalWidth = $(this).width();
                    var txtOmle = _this.text();

                    $txtR.text(txtOmle);
                    $body.append($txtR);

                    if ($txtR.width() >= orinalWidth * 1.2) {
                    _this.addClass("no-ellipsis");
                    } else {
                    _this.removeClass("no-ellipsis");
                    }
                });
                }
            }, 250);

            setTimeout(function () {
                $(".txtEllipsis").remove();
            }, 1000);
        },
        moveLocation(location) {
            // 2021-01-13 paperId,TodoId를 이용 할일이 등록된 보드의 블럭아이디 조회.
            let obj = this;
            let reqData = {};
            reqData.params = {
                todoId: location.todoId,
                paperId: location.paperId
            };
            reqData.url = "/api/copaper/todo/getTodoPaperBlockId";
            reqData.method = "post";
 
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then((res) => {
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    window.open("/general/boardTarget/" + location.paperId + "/" + res.result.paperBlockId, "_blank"); 
                }
            })
            .catch((err) => {
                console.log("axios err => ", err);
            }); 
        },
    },
}
</script>
<style scoped>
#modals-container >>> .v--modal-overlay .v--modal-box {
  overflow: visible;
}

.txtEllipsis {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}
.multi-ellipsis {
  overflow: hidden;
  position: relative;
  max-height: 2.8em;
  line-height: 1.4;
  text-align: justify;
  text-overflow: ellipsis;
  word-wrap: break-word;
  word-break: break-all;
}
.multi-ellipsis:before,
.multi-ellipsis:after {
  content: "...";
  line-height: 1;
  position: absolute;
  right: 0;
  top: 1.6em;
  -ms-wrap-flow: start;
}
.multi-ellipsis:after {
  background: currentColor !important;
  color: #fff !important;
  top: auto;
}
.multi-ellipsis.no-ellipsis::before,
.multi-ellipsis.no-ellipsis::after {
  display: none;
}
@supports (-webkit-line-clamp: 2) {
  .multi-ellipsis {
    -webkit-box-orient: vertical;
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
  }
  .multi-ellipsis::before,
  .multi-ellipsis::after {
    content: normal;
  }
}
</style> 


// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/TodoPersonal.vue